import { REDUCER_KEY_HEATMAP_SETTINGS_DIALOG } from './constants';

export const heatmapSettingsDialogState = (state) => state.get(REDUCER_KEY_HEATMAP_SETTINGS_DIALOG);
export const settingsResponse = (state) => heatmapSettingsDialogState(state).settingsResponse;
export const isLoading = (state) => !settingsResponse(state);
